module.exports = __webpack_public_path__ + "static/media/subscription.d81b59a4.svg";